import { Component } from '@angular/core';
import { MachineStepBaseComponent } from '../machine-step-base.component';
import { RotecFormGroupConfigV2, FormsModuleV2 } from '@schenck/rotec-components';
import { MachineTaskUpsertModel } from '../../upsert-machine-task-wizard.component';

@Component({
  selector: 'ma-machine-scheduling-step',
  templateUrl: './scheduling-step.component.html',
  imports: [FormsModuleV2],
})
export class MachineSchedulingStepComponent extends MachineStepBaseComponent {
  public schedulingFields: RotecFormGroupConfigV2<MachineTaskUpsertModel> = [
    { key: 'id' },
    { key: 'scheduling' },
    { key: 'dueDate' },
    {
      type: <any>'scheduling',
      key: <any>'__scheduling',
      props: {},
    },
    {
      type: <any>'alarm',
      key: 'alarm',
    },
  ];
}
